<!--
 * @Author: wjd
 * @Date: 2021-03-19 17:06:47
 * @LastEditTime: 2021-06-11 23:31:47
 * @LastEditors: ChaoLuanDi
 * @Description: 资源图标
 * @FilePath: \ty-electron-template\src\renderer\components\vm-resico\index.vue
-->
<template>
  <span :class="`res-ico-${size} res-ico ${type}`" :type="type"></span>
</template>
<script>
export default {
  props: ["size", "type"],
  data() {
    return {};
  },
};
</script>
<style scoped lang="less">
/* 图标样式 begin */
.res-ico {
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  background: url("assets/ppt.png") no-repeat center center;
  background-size: 100% 100%;
  margin-right: 10px;
  &.ppt {
    background-image: url("assets/ppt.png");
  }
  &.pptx {
    background-image: url("assets/ppt.png");
  }
  &.img {
    background-image: url("assets/image.png");
  }
  &.jpeg {
    background-image: url("assets/image.png");
  }
  &.bmp {
    background-image: url("assets/image.png");
  }
  &.png {
    background-image: url("assets/image.png");
  }
  &.gif {
    background-image: url("assets/image.png");
  }
  &.jpg {
    background-image: url("assets/image.png");
  }
  &.JPG {
    background-image: url("assets/image.png");
  }
  &.excel {
    background-image: url("assets/excel.png");
  }
  &.xlsx {
    background-image: url("assets/excel.png");
  }
  &.xls {
    background-image: url("assets/excel.png");
  }
  &.link {
    background-image: url("assets/link.png");
  }
  &.video {
    background-image: url("assets/video.png");
  }
  &.pdf {
    background-image: url("assets/pdf.png");
  }
  &.doc {
    background-image: url("assets/doc.png");
  }
  &.docx {
    background-image: url("assets/doc.png");
  }
  &.default {
    background-image: url("assets/default.png");
  }
  &.audio {
    background-image: url("assets/audio.png");
  }
  &.mp4,
  &.avi,
  &.wmv,
  &.asf,
  &.swf {
    background-image: url("assets/video.png");
  }
  &.flv {
    background-image: url("assets/video.png");
  }
  &.mp3,
  &.wma,
  &.wav,
  &.m4a {
    background-image: url("assets/audio.png");
  }
  &.edu {
    background-image: url("assets/edu.png");
  }
  &.exe {
    background-image: url("assets/exe.png");
  }
  &.file {
    background-image: url("assets/file.png");
  }
  &.flash {
    background-image: url("assets/flash.png");
  }
  &.html {
    background-image: url("assets/html.png");
  }
  &.package {
    background-image: url("assets/package.png");
  }
  &.tir {
    background-image: url("assets/tir.png");
  }
  &[type="tir"]{
    width: 32px!important;
    height: 32px!important;
  }
  &.rar,
  &.zip,
  &[type="7z"]{
    background-image: url("assets/rar.png");
  }
  &.resources {
    background-image: url("assets/resources.png");
  }
  &.undefined {
    background-image: url("assets/resources.png");
  }
  &.study {
    background-image: url("assets/study.png");
  }
  &.txt {
    background-image: url("assets/txt.png");
  }
  &.video {
    background-image: url("assets/video.png");
  }
}
.res-ico-mid {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 6px;
}

.res-ico-big {
  width: 84px;
  height: 84px;
  min-width: 84px;
  border-radius: 6px;
}
.res-ico-100 {
  width: 100px;
  height: 100px;
  min-width: 100px;
  border-radius: 6px;
}

/* 图标样式 begin */
</style>
